// 时间颗粒度
export enum DateType {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  WEEK = 'WEEK',
}

export const DateTypeDisplay = {
  [DateType.DAY]: '按日',
  [DateType.WEEK]: '按周',
  [DateType.MONTH]: '按月',
  [DateType.YEAR]: '按年',
};

export const DateTypeDayjs = {
  [DateType.DAY]: 'd',
  [DateType.WEEK]: 'w',
  [DateType.MONTH]: 'M',
  [DateType.YEAR]: 'y',
};

export const DatePickerDisplay = {
  [DateType.DAY]: 'date',
  [DateType.WEEK]: 'week',
  [DateType.MONTH]: 'month',
  [DateType.YEAR]: 'year',
};
